import { render, staticRenderFns } from "./TextareaWithValidation.vue?vue&type=template&id=10cc7d9a&"
import script from "./TextareaWithValidation.vue?vue&type=script&lang=js&"
export * from "./TextareaWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./TextareaWithValidation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports